<template>
    <!-- 培训机构列表 -->
    <div>
        <top :keyword="''" :tab="'school'"></top>
        <div class="detail-main">
            <div class="all">
                <div class="inall">
                    <pic :src="school.logoUrl" alt />
                    <p>{{school.name}}</p>
                    <span class="time">创建时间：{{school.createTime}}</span>
                    <span class="phone">联系电话：{{school.handlePhone}}</span>
                    <span class="address">详细地址：{{school.address}}</span>
                </div>
            </div>
            <div class="gz">
                <div class="selectkind" style="position:absolute;left:0;">
                    <span>工种：</span>
                    <el-select
                        v-model="occupationId"
                        style="width:167px;margin-right: 25px;"
                        placeholder="请选择工种"
                        clearable
                    >
                        <el-option
                            v-for="option in arr"
                            :key="option.id"
                            :value="option.id"
                            :label="option.name"
                        ></el-option>
                    </el-select>
                    <el-select
                        v-model="gradeId"
                        style="width:167px;margin-right: 25px;"
                        placeholder="请选择等级"
                        clearable
                    >
                        <el-option
                            v-for="grade in grades"
                            :key="grade.id"
                            :value="grade.id"
                            :label="grade.name"
                        ></el-option>
                    </el-select>
                </div>
            </div>
            <classes
                v-if="school.id"
                :params="{'name': name, 'offlineOrgId': school.id, 'occupationId': occupationId, 'gradeId': gradeId}"
            ></classes>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from './top'
import classes from './classes'
import bottom from './bottom'

export default {
    name: 'SchoolClasses',
    data() {
        return {
            school: {},
            details: [],
            arr: [], //工种list
            grades: [],
            occupationId: '',
            gradeId: '',
            name: ''
        }
    },
    computed: {},
    created() {
        this.getOccupation()
        this.getOccuGrade()
        this.getAll()
    },
    methods: {
        // 工种列表
        getOccupation() {
            let platformId = localStorage.getItem('datas')
            this.$axios
                .get(this.$managePath + '/offline/api/occupation/list', {
                    params: { platformId }
                })
                .then(res => {
                    this.arr = res.data.data
                })
        },
        // 工种等级列表
        getOccuGrade() {
            let platformId = localStorage.getItem('datas')
            this.$axios
                .get(this.$managePath + '/offline/api/occupationGrade/list', {
                    params: { platformId }
                })
                .then(res => {
                    this.grades = res.data.data
                })
        },
        getAll() {
            // 接收到school.vue页面传递的id
            let id = this.$route.params.id
            var qs = require('qs')
            this.$axios
                .get(this.$managePath + '/offline/api/org/detail/' + id)
                .then(res => {
                    this.school = res.data.data
                })
        }
    },
    beforeMount() {},
    watch: {},
    components: {
        bottom: bottom,
        top: top,
        classes
    }
}
</script>
<style scoped>
@import '../assets/css/iconfont.css';
@import '../assets/css/common.css';
@import '../assets/css/index.css';
@import '../assets/css/cms.css';
* {
    list-style: none;
}
.detail-main {
    height: 1000px;
}
.all {
    width: 100%;
    height: 200px;
    margin-top: 10px;
}
.inall {
    width: 1184px;
    height: 100%;
    /* background: #ccc; */
    margin: 0 auto;
    position: relative;
}
.inall img {
    width: 150px;
    height: 150px;
    float: left;
    margin-top: 25px;
}
.inall p {
    position: absolute;
    left: 180px;
    top: 17px;
    font-size: 24px;
}
.inall span {
    left: 180px;
    font-size: 18px;
}
.time {
    position: absolute;
    top: 60px;
}
.phone {
    position: absolute;
    top: 90px;
}
.address {
    position: absolute;
    top: 120px;
}
.gz {
    width: 1184px;
    height: 100px;
    /* background: #000; */
    margin: 0 auto;
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/schoolClasses.vue